<template>
    <div class="subscription--inner">
        <div class="subscription--error">
            {{ translations.subscription.error }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'SubscriptionScreenError',

    data () {
        return {
            translations: window.script_var.translations
        }
    }
}
</script>
